import { jsx as r } from "react/jsx-runtime";
import { u as a } from "./index-6a632112.mjs";
import { s as e, c as l, f as h, a as g, e as $, r as b } from "./themes-5f0b3c3d.mjs";
import { l as m } from "./lineHeights-72d3110c.mjs";
import { z as y } from "./zIndices-d07533f3.mjs";
import "react";
const k = a.div`
  position: absolute;
  z-index: ${y.mediaDisclosureButton};
  height: ${e["6x"]};
  min-width: ${e["6x"]};
  margin: 2px;

  bottom: ${({ $containerPosition: i }) => i.bottom || "16px"};
  ${({ $alignment: i, $containerPosition: n }) => `${i === "bottom-left" ? `left:${n?.left}` : `right:${n?.right}`}`};
  display: flex;
  gap: ${({ $itemGap: i }) => i};
`, w = a.button`
  // Typography
  color: ${l.brandTwilight[1e3]};
  text-align: center;
  font-family: ${h.inter};
  font-size: ${g.xxsmall};
  font-style: normal;
  font-weight: ${$.semiBold.XS.fontWeight};
  line-height: ${m.xsmall};
  overflow: hidden;

  // Layout
  display: flex;
  width: ${e["6x"]};
  height: ${e["6x"]};
  padding: ${e["1x"]};
  justify-content: center;
  align-items: center;
  gap: 0px;
  flex-shrink: 0;

  // Style
  border-radius: ${e["3x"]};
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;

  &:hover {
    background: ${l.accentBlue[100]};
  }

  &:focus-visible {
    outline: none;
  }
`, B = a.div`
  &:focus-within {
    border-radius: ${b["1x"]};
    outline-offset: 2px;
    outline: 2px solid ${l.accentBlue[1e3]};
  }
`, W = ({
  id: i,
  links: n,
  accessibilityOption: s,
  style: c,
  itemGap: d = "8px",
  alignment: p = "bottom-right",
  containerPosition: u = {
    left: "20px",
    right: "20px",
    bottom: "16px"
  }
}) => {
  const f = (x) => x.map((o, D) => /* @__PURE__ */ r(B, { children: /* @__PURE__ */ r(
    w,
    {
      onClick: (t) => o.onClick && o.onClick(t, o.id),
      onKeyDown: (t) => {
        (t.code === "Enter" || t.code === "Space") && (t.preventDefault(), o.onClick && o.onClick(t, o.id));
      },
      id: o.id,
      "aria-label": o.accessibilityOption?.button?.ariaLabel,
      children: o.linkTitle
    }
  ) }, o.linkTitle));
  return n.length > 0 ? /* @__PURE__ */ r(
    k,
    {
      id: i,
      "aria-label": s?.div?.ariaLabel,
      style: c,
      $itemGap: d,
      $alignment: p,
      $containerPosition: u,
      children: f(n)
    }
  ) : null;
};
export {
  W as MediaDisclosureButton
};
